import { render, staticRenderFns } from "./hdqForm.vue?vue&type=template&id=ba996838&scoped=true"
import script from "./hdqForm.vue?vue&type=script&lang=js"
export * from "./hdqForm.vue?vue&type=script&lang=js"
import style0 from "./hdqForm.vue?vue&type=style&index=0&id=ba996838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba996838",
  null
  
)

export default component.exports